import React, { useCallback, useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from "@material-ui/icons/Search";
import { IDocumentListProps } from "../../../../../@types/components/documentListProps.types";
import { IAdminDocument } from "../../../../../@types/documentAdmnstration.types";

const SearchBar = ({
	documentList,
	handleSearchFile
}: {
	documentList: IAdminDocument[];
	handleSearchFile: (event: any, newValue: string | null) => void;
}) => {
	const [documentNames, setDocumentNames] = useState<string[]>([]);
	const handleChangeDocumentNames = useCallback(() => {
		const tempArr: string[] = [];
		documentList.forEach((document: any) => {
			tempArr.push(document.name);
		});
		setDocumentNames(tempArr);
	}, [documentList]);

	useEffect(() => {
		handleChangeDocumentNames();
	}, [handleChangeDocumentNames]);

	return (
		<div className="search">
			<Autocomplete
				freeSolo
				options={documentNames}
				onInputChange={(e, newValue) => handleSearchFile(e, newValue)}
				// eslint-disable-next-line prettier/prettier
				renderInput={params => (
					<TextField
						{...params}
						variant="outlined"
						margin="normal"
						fullWidth
						placeholder="Search..."
						// eslint-disable-next-line arrow-parens
						InputProps={{
							...params.InputProps,
							startAdornment: (
								<>
									<SearchIcon style={{ marginRight: "8px", color: "gray" }} />
									{params.InputProps.startAdornment}
								</>
							)
						}}
					/>
				)}
			/>
		</div>
	);
};

export default SearchBar;
